// src/redux/slices/engagementSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    createEngagement,
    createEngagementSuccess,
    createEngagementError,
} from '../actions/engagementActions'; 

interface EngagementState {
    createEngagement: {
        loading: boolean;
        error: string | null;
    };
    terminateEngagement: {
        loading: boolean;
        error: string | null;
    };
    data: unknown ;
    params: Record<string, any>;
}

// Define the initial state
const initialState: EngagementState = {
    createEngagement: {
        loading: false,
        error: null,
    },
    terminateEngagement: {
        loading: false,
        error: null,
    },
    data: null,
    params: {},
};


const engagementSlice = createSlice({
    name: 'engagement',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createEngagement, (state) => {
                state.createEngagement.loading = true;
                state.createEngagement.error = null;
                state.data = null;
            })
            .addCase(createEngagementError, (state, action: PayloadAction<{ error: string }>) => {
                state.createEngagement.loading = false;
                state.createEngagement.error = action.payload.error;
            })
            .addCase(createEngagementSuccess, (state, action: PayloadAction<{ data: any }>) => {
                state.createEngagement.loading = false;
                state.data = action.payload.data;
            });
    },
});

export default engagementSlice.reducer;
